import { render } from "./RichText.vue?vue&type=template&id=22b6fe15&ts=true"
import script from "./RichText.vue?vue&type=script&lang=tsx"
export * from "./RichText.vue?vue&type=script&lang=tsx"

import "./RichText.vue?vue&type=style&index=0&id=22b6fe15&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__